<template>
  <LinkButton
    :tag="tag"
    :to="to"
    :disabled="disabled"
    :tabindex="disabled ? undefined : tabIndex"
    @click="emitClick"
  >
    <slot />
  </LinkButton>
</template>

<script>
import { LinkButton } from '@i22/td-longtail-vue-components';

export default {
  name: 'DeactivatableLink',
  components: { LinkButton },
  props: {
    to: {
      type: [Object, String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    tag() {
      if (this.disabled) return 'span';
      if (this.emitOnlyClick) return 'button';
      return 'nuxt-link';
    },
    tabIndex() {
      return this.disabled ? -1 : undefined;
    },
  },
  methods: {
    emitClick() {
      if (this.disabled) return;
      this.$emit('click', this.to);
    },
  },
};
</script>
